import {getAxiosInstance, requestConfig} from "../../http-common";
import { GetFieldMappingsRequest } from "../../models/fieldmappings/GetFieldMappingsRequest";
import { TestFieldMappingRequest } from "../../models/fieldmappings/TestFieldMappingRequest";
import {CopyBulkFieldMappingRequest} from "../../models/fieldmappings/CopyBulkFieldMappingRequest";

const RESOURCE_NAME = "fieldmappings";

const getAll = (model: GetFieldMappingsRequest) => {
  const http = getAxiosInstance();
  let fromTableId = model.fromTableId;
  if (model.fromTableId !== -1) {
    fromTableId = model.fromTableId;
  }
  return http.get(
    `${RESOURCE_NAME}?groupCode=${model.groupCode}&toTableId=${model.toTableId}&fromTableId=${fromTableId}`,
    requestConfig()
  );
};

const create = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, model, requestConfig());
};

const update = (model: any) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${model.id}`, model, requestConfig());
};

const remove = (model: any) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${model.id}`, requestConfig());
};

const bulkUpdate = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/UpdateMultiple`, model, requestConfig());
};

const automap = (model: any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/Automap`, model, requestConfig());
};

const test = (model: TestFieldMappingRequest) => {
  const http = getAxiosInstance();
  return http.post(
    `${RESOURCE_NAME}/test`,
    model,
    requestConfig()
  );
};
const copyBulk = (model: CopyBulkFieldMappingRequest) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/copyBulk`, model, requestConfig());
};

const readAll = (groupCode: string, entity: string) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/readAll?groupCode=${groupCode}&entity=${entity}`, requestConfig());
};

const FieldMappingsService = {
  getAll,
  create,
  update,
  remove,
  bulkUpdate,
  test,
  automap,
  copyBulk,
  readAll
};
export default FieldMappingsService;
